const parseFecha = (fecha) => {
    var dateUTC = new Date(fecha);    
    var date = new Date( dateUTC.getTime() + ( dateUTC.getTimezoneOffset() * 60 * 1000 ) );

    var meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    var dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

    return dias[date.getDay()] + " " + date.getDate() + " de " + meses[date.getMonth()];
}

export default parseFecha;